import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ConfirmedValidator } from './confirmed.validator'
import { LoaderService } from 'src/modules/base/services/loader.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { ADService } from 'src/app/ad.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { LoginServiceService } from '../service/login-service.service';
import { UtilService } from 'src/modules/base/services/util.service';

@Component({
  selector: 'app-otp-varification',
  templateUrl: './otp-varification.component.html',
  styleUrls: ['./otp-varification.component.scss'],
  standalone: false
})
export class OtpVarificationComponent {
  @Input() data: any;
  @Input() fromPage: any
  @Output() emitBackEvent = new EventEmitter<any>();
  form: FormGroup = new FormGroup({});
  isOTPVerified: boolean = false;
  timer: number;
  showTimer: boolean = false;
  submitted: boolean = false;
  eye: string = "fa-eye";
  eye1: string = "fa-eye";
  checkPattern: any = '^[a-zA-Z0-9!@#$&()\\`+,\"]*$'
  headerInfo: any = { showDefaultLogo: false };
  loginInfo = {};
  @Input() compConfig: any = {};

  constructor(
    private fb: FormBuilder,
    private baseService: BaseService,
    private alertService: AlertsService,
    private loader: LoaderService,
    private commuication: CommunicationService,
    public adService: ADService,
    private loginService: LoginServiceService,
    public utilService: UtilService,
    public appService: AppService,
  ) {
    this.form = fb.group({
      password: ['', [Validators.required]],
      confirm_password: ['', [Validators.required]],
      login_id: ['', Validators.required]
    }, {
      validator: ConfirmedValidator('password', 'confirm_password')
    })
  }

  ngOnInit() {
    this.headerInfo = this.appService.getAppHeader();
    console.log("headerInfo", this.headerInfo);
    if (this.data.otp_verified == true && this.data.page_no == 2) {
      this.isOTPVerified = true
    } else {
      this.timerFn()
    }
  }

  get f() {
    return this.form.controls;
  }

  otp: string;
  showOtpComponent = true;
  @ViewChild('ngOtpInput') ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  };

  isVerified: boolean = true;
  onOtpChange(otp) {
    this.otp = otp;
  }

  setVal(val) {
    this.ngOtpInput.setValue(val);
  }

  verifyOtp() {
    this.loader.showSpinner();
    let data = {
      "login_id": this.data.login_id,
      "account_url": this.data.account_url,
      "otp_no": this.otp,
      "first_name": this.data.name_.text,
      "mobile_no": this.data.telecom
    }
    this.baseService.add(data, 'verify_otp', true, 'account-management', 'VERIFY_OTP').subscribe(
      // this.baseService.action(data,'' , '', '').subscribe(
      (res) => {
        this.loader.hideSpinner();
        if (res.errCode == 0) {
          if (this.headerInfo.skip_loginid) {
            this.skipRegistration()
          }
          else if (this.adService.isADLogin() && this.compConfig.accessToken != undefined && this.compConfig.adType != undefined) {
            this.adRegistration();
          }
          else {
            this.isOTPVerified = true;
            this.fromPage = 2;
          }
        } else {
          this.alertService.error(res.message)
          this.loader.hideSpinner();
        }
      },
      err => {
        this.loader.hideSpinner();
      }
    )
  }

  resetpassword() {
    this.loader.showSpinner();
    this.submitted = true;

    if (this.form.invalid) {
      this.loader.hideSpinner();
      return;
    }

    let data = {
      "login_id": this.data.login_id,
      "user_login_id": this.form.controls['login_id'].value,
      "account_url": this.data.account_url,
      "password": this.form.controls['password'].value,
      "confirm_password": this.form.controls['confirm_password'].value,
      "mobile_no": this.data.telecom,
      "first_name": this.data.patient_name
    }
    this.baseService.add(data, 'set_password', true, 'patient-registration', 'ADD').subscribe(
      (res) => {
        if (res.errCode == 0) {
          this.loader.hideSpinner();
          this.submitted = false;
          this.alertService.success('Patient Successfully registered!')
          let val =
          {
            "set_password": true
          }
          this.login(this.form.controls['login_id'].value)
          // this.emitBackEvent.emit(val)

        } else {
          this.alertService.error(res.message);
          this.loader.hideSpinner();
        }
      }, err => {
        this.loader.hideSpinner();
      }
    )
  }


  skipRegistration() {
    this.loader.showSpinner();
    this.submitted = true;
    let data = {
      "login_id": this.data.login_id,
      "account_url": this.data.account_url,
      "mobile_no": this.data.telecom,
      "first_name": this.data.patient_name
    }
    this.baseService.add(data, 'set_password', true, 'patient-registration', 'login_skip').subscribe(
      (res) => {
        if (res.errCode == 0) {
          this.loader.hideSpinner();
          this.submitted = false;
          this.alertService.success('Patient Successfully registered!')
          let val =
          {
            "set_password": true
          }
          this.login(res.resource[0].login_id)
          //  this.emitBackEvent.emit(val)

        } else {
          this.alertService.error(res.message);
          this.loader.hideSpinner();
        }
      }, err => {
        this.loader.hideSpinner();
      }
    )
  }

  login(loginId) {
    this.loader.showSpinner();
    this.loginInfo['login_id'] = loginId;
    this.loginInfo['password'] = this.otp;
    this.loginInfo['account_url'] = this.data.account_url;
    let obj = { "priOtpLogin": true }
    this.loginInfo['extra_data'] = obj;
    if (this.utilService.isMobile()) {
      this.loginInfo['user_agent'] = 'mobile';
    } else {
      this.loginInfo['user_agent'] = 'web'
    }
    var menuParser: any = false;
    try {
      if (this.appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
        menuParser = new this.appService._appData.DECORATOR_DEF['menuParseDecorator']();
      }
    } catch (e) {
      console.warn(e)
    }
    var loginInfo = this.loginService.encrypt(JSON.parse(JSON.stringify(this.loginInfo)));
    this.baseService.add(loginInfo, 'login').subscribe(
      (data: any) => {
        this.submitted = false;
        if (data.errCode == -1) {
          this.alertService.error(data.message);
          this.loader.hideSpinner();
          let val =
          {
            "set_password": true
          }
          this.emitBackEvent.emit(val)
        }
        else {
          if (data.resource != undefined && data.resource.length) {
            let newData = this.loginService.decryptLoginInfo(data);
            if (newData?.resource?.[0]) newData.resource[0].screen_name = "self_registration";
            this.loginService.buildApplication(newData, menuParser);
          } else {
            this.alertService.error(data.message);
            this.loader.hideSpinner();
          }
        }
      });
  }

  adRegistration() {
    this.loader.showSpinner();
    this.submitted = true;
    let data = {
      "login_id": this.data.login_id,
      "account_url": this.data.account_url,
      "mobile_no": this.data.telecom,
      "first_name": this.data.patient_name,
      "adType": this.compConfig.adType,
      "adPassword": this.compConfig.accessToken
    }
    this.baseService.add(data, 'ad_set_password', true, 'account-management', 'ad_login_skip').subscribe(
      (res) => {
        if (res.errCode == 0) {
          this.loader.hideSpinner();
          this.submitted = false;
          this.alertService.success('Patient Successfully registered!')
          this.backToLogin();
        } else {
          this.alertService.error(res.message);
          this.loader.hideSpinner();
          this.backToPatientRegistration();
        }
      }, err => {
        this.loader.hideSpinner();
        this.backToPatientRegistration();
      }
    )
  }

  resendCode() {
    this.loader.showSpinner()
    this.timerFn()
    let data = {
      "login_id": this.data.login_id,
      "account_url": this.data.account_url
    }
    this.baseService.add(data, 'verify_otp', true, 'account-management', 'RESEND_OTP').subscribe(
      // this.baseService.action(data, 'RESEND_OTP', 'account-management', 'verify_otp').subscribe(
      (res) => {
        this.loader.hideSpinner();
        if (res) {
          this.commuication.emitResetForm({ value: true })
        }
      }
    )
  }

  backToPatientRegistration() {
    let val = {
      "back": true
    }

    this.emitBackEvent.emit(val)
  }

  backToLogin() {
    let val = {
      "login": true
    }

    this.emitBackEvent.emit(val)
  }

  resetForm() {

  }

  backToOtpVerify() {
    this.form.reset()
    if (this.fromPage == 1) {
      this.backToPatientRegistration()
    } else {
      this.isOTPVerified = false;
    }
  }

  timerFn() {
    this.timer = 60;
    this.showTimer = true;
    let timerInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000)
  }
}
